module.exports = __webpack_public_path__ + "img/card1.52959f9e.png";